export const EVENT = {
  SAVE_COURSE_TITLE: "SAVE_COURSE_TITLE",
  SAVE_SECTION_TITLE: "SAVE_SECTION_TITLE",
  SAVE_ACTIVITY_TITLE: "SAVE_ACTIVITY_TITLE",
  SAVE_ACTIVITY_OPTIONAL: "SAVE_ACTIVITY_OPTIONAL",
  LESSON_COVER_NAVIGATION: "LESSON_COVER_NAVIGATION",
  SECTION_COVER_NAVIGATION: "SECTION_COVER_NAVIGATION",
  SECTION_END_NAVIGATION: "SECTION_END_NAVIGATION",
  LESSON_END_NAVIGATION: "LESSON_END_NAVIGATION",
  ACTIVITY_NAVIGATION: "ACTIVITY_NAVIGATION",
  MONITOR_NAVIGATION: "MONITOR_NAVIGATION",
  DELETE_SECTION: "DELETE_SECTION",
  DELETE_ACTIVITY: "DELETE_ACTIVITY",
  REORDER_SECTION: "REORDER_SECTION",
  REORDER_ACTIVITY: "REORDER_ACTIVITY",
  ADD_SECTION: "ADD_SECTION",
  ADD_ACTIVITY: "ADD_ACTIVITY",
  ADD_NEW: "ADD_NEW",
  DUPLICATE_ACTIVITY: "DUPLICATE_ACTIVITY",
  TOGGLE_SECTION: "TOGGLE_SECTION",
  TOGGLE_ACTIVITY_ACCESS: "TOGGLE_ACTIVITY_ACCESS",
  TOGGLE_RESOURCE_COMPLETION_PREREQUISITE_CONTENT_POPUP:
    "TOGGLE_RESOURCE_COMPLETION_PREREQUISITE_CONTENT_POPUP",
  TOGGLE_VIEW_PREREQUISITE_CONTENT_POPUP: "TOGGLE_VIEW_PREREQUISITE_CONTENT_POPUP",
  SAVE_RULE_CONDITION_RESOURCE_PREREQUISITE: "SAVE_RULE_CONDITION_RESOURCE_PREREQUISITE",
  SAVE_SEQUENTIAL_SECTION_COMPLETION_PREREQUISITE:
    "SAVE_SEQUENTIAL_SECTION_COMPLETION_PREREQUISITE",
  SAVE_SEQUENTIAL_ACTIVITY_COMPLETION_PREREQUISITE:
    "SAVE_SEQUENTIAL_ACTIVITY_COMPLETION_PREREQUISITE",
  SAVE_COURSE_COVER_VISIBILITY: "SAVE_COURSE_COVER_VISIBILITY",
  SAVE_SECTION_COVER_VISIBILITY: "SAVE_SECTION_COVER_VISIBILITY",
};

export const EDITOR_FIELD_DEFAULT_VALUES = {
  ACTIVITY_TITLE: "Untitled",
  LESSON_TITLE: "Untitled",
  SECTION_TITLE: "", // allow to be empty
};

export const VALIDATION = {
  MAX_CHILD_QUESTION: 26,
  MAX_TOTAL_SUB_QUESTION: 40,
  MAX_ACTIVITIES: 20,
  MAX_SECTION: 20,
};

export const ROUTE_NAME = {
  COURSE_COVER: "CourseCover",
  SECTION_COVER: "SectionCover",
  SECTION_END: "SectionEnd",
  COURSE_END: "CourseEnd",
  ACTIVITY_PAGE: "ActivityPage",
  WAITING_ROOM: "WaitingRoom",
};

export const COMPLETION_STATUS = {
  NEW: "new",
  INCOMPLETE: "incomplete",
  COMPLETED: "completed",
};

export const MARKING_STATUS = {
  RELEASE: "RELEASE",
  PENDING_MARK: "PENDING_MARK",
  MARKED: "MARKED",
};

export const QUIZ_TEST_MODE = {
  PRACTICE: "PRACTICE",
  TEST_AUTO_RELEASE: "TEST_AUTO_RELEASE",
  TEST_TEACHER_RELEASE: "TEST_TEACHER_RELEASE",
};

export const PROGRESS_STATUS_OPTIONS = {
  IN_PROGRESS: "In Progress",
  COMPLETED: "Completed",
  OVERDUE: "Overdue",
};

export const ACTIVITY_RESTRICTION = {
  SUBGROUP: "SUBGROUP",
  NONE: "NONE",
  TEAM: "TEAM",
};

export const OPERATOR = {
  AND: "AND",
  OR: "OR",
} as const;

export type Operator = keyof typeof OPERATOR;

export const ACTIVITY_TYPE = {
  ACTIVITY: "ACTIVITY",
  ACTIVITY_QUIZ: "ACTIVITY_QUIZ",
} as const;

export type ActivityType = keyof typeof ACTIVITY_TYPE;

export const GAME_AWARD_TYPE = {
  GAME_STORY: "GAME_STORY",
  COLLECTIBLE: "COLLECTIBLE",
  GAME_AVATAR: "GAME_AVATAR",
} as const;

export type GameAwardType = keyof typeof GAME_AWARD_TYPE;

export const PREREQUISITE_TYPE = {
  ACTIVITY: "ACTIVITY",
  QUIZ_RANK: "QUIZ_RANK",
  GAME_AWARD: "GAME_AWARD",
  LEVEL_UP: "LEVEL_UP",
  GAME_CHOICE: "GAME_CHOICE",
} as const;

export type PrerequisiteType = keyof typeof PREREQUISITE_TYPE;

export const CRITERION_VALUE = {
  RESOURCE_COMPLETION: "RESOURCE_COMPLETION",
  QUIZ_SCORE: "QUIZ_SCORE",
  RESOURCE_SCORE: "RESOURCE_SCORE",
  RESOURCE_START: "RESOURCE_START",
  GAME_AWARD: "GAME_AWARD",
  GAME_CHOICE: "GAME_CHOICE",
  LEVEL_UP: "LEVEL_UP",
  QUIZ_RANK: "QUIZ_RANK",
} as const;

export type CriterionValue = keyof typeof CRITERION_VALUE;
